import React, { useContext, useState } from 'react';
import PropTypes from 'prop-types';
import { Add, Delete, Edit } from '@mui/icons-material';
import RowContextMenu from '../../components/DataGrid/RowContextMenu';
import DataGrid from '../../components/DataGrid/DataGrid';
import UserEditor from './UserEditor';
import DetailDialog from '../../components/DetailDialog/DetailDialog';
import { Box, FormControlLabel, Switch, Typography } from '@mui/material';
import ConfirmationDialog from '../../components/DetailDialog/ConfirmationDialog';
import { AppContext } from "../../contexts/AppContext"
import { useMutation, useQueryClient } from "@tanstack/react-query"
import axios from 'axios';

const Users = ({ id }) => {
    const { state } = useContext(AppContext)
    const [openEditor, setOpenEditor] = useState(false);
    const [current, setCurrent] = useState(null);
    const [openDialog, setOpenDialog] = useState(false)
    const [dialogProps, setDialogProps] = useState({
      type: "info",
      title: "",
      message: "",
      confirmText: "",
      cancelText: "",
    })
    const queryClient = useQueryClient()

  const mutation = useMutation({
    mutationFn: async ({ formData, id }) => {
      const url = `/api/admin/users/${id}/toggleApproval`

      const method = "post" // Choose PUT or POST

      const response = await axios({
        method,
        url,
        data: formData,
        headers: {
          Authorization: state.token ? `Bearer ${state.token}` : "",
          "Content-Type": "multipart/form-data",
        },
      })

      return response.data
    },
    onSuccess: () => {
      queryClient.invalidateQueries(["users"])
    },
    onError: (error) => {
      console.error("Error saving user:", error)
    },
  })

    const handleOpenDialog = (type) => {
      let props = {}
  
      switch (type) {
        case "delete":
          props = {
            type: "delete",
            title: "Confirm Deletion",
            message: "Are you sure you want to delete this item? This action cannot be undone.",
            confirmText: "Delete Item",
            cancelText: "Keep Item",
          }
          break
        case "warning":
          props = {
            type: "warning",
            title: "Warning",
            message: "This action may have consequences. Are you sure you want to proceed?",
            confirmText: "Proceed Anyway",
            cancelText: "Go Back",
          }
          break
        case "success":
          props = {
            type: "success",
            title: "Confirm Submission",
            message: "Your form is ready to be submitted. Would you like to proceed?",
            confirmText: "Submit Now",
            cancelText: "Review Again",
          }
          break
        case "question":
          props = {
            type: "question",
            title: "Confirmation Needed",
            message: "Do you want to disable/enable this user?",
            confirmText: "Yes",
            cancelText: "No",
          }
          break
        default:
          props = {
            type: "info",
            title: "Confirm Action",
            message: "Are you sure you want to perform this action?",
            confirmText: "Confirm",
            cancelText: "Cancel",
          }
      }
  
      setDialogProps(props)
      setOpenDialog(true)
    }
  
    const handleClose = () => {
      setOpenDialog(false)
    }
  
    const handleConfirm = () => {
      console.log("Action confirmed!", dialogProps.type)
      const formData = new FormData()
      formData.append("withCredentials", true)

      mutation.mutate({
        formData,
        id: current.id,
      })
    }

    const columns = [
        { field: "name", headerName: "Name", align: "left", filterable: true, permanent: true },
        { field: "phone", headerName: "Phone", align: "left", filterable: true,},
        { field: "email", headerName: "Email", align: "left", filterable: true,},
        { field: "isApproved", headerName: "Status", align: "right", 
            render: row => (
              <FormControlLabel
                control={<Switch checked={row.isApproved} onChange={(e) => {setCurrent(row);handleOpenDialog("question")}} color="primary" />}
                label={
                  <Typography variant="body1">
                    <Typography
                      component="span"
                      color={row.isApproved ? "success.main" : "text.secondary"}
                      fontWeight="medium"
                    >
                      {row.isApproved ? "Active" : "Inactive"}
                    </Typography>
                  </Typography>
                }
                sx={{ ml: 0 }}
              />
            ),
            filterable: true,},
        ];
    
      // Define actions outside the RowContextMenu
      const rowActions = [
        { name: "Edit", icon: <Edit fontSize="small" />, onClick: (row) => console.log("Editing row:", row) },
        { name: "Delete", icon: <Delete fontSize="small" style={{ color: 'red' }} />,  onClick: (row) => console.log("Deleting row:", row)},
    ];

    const headerActions = [
            { name: "Add", icon: <Add fontSize="small" color='secondary' />, onClick: () => setOpenEditor(true) },
        ];
    
    const CustomRowContextMenu = (props) => {
        return <RowContextMenu {...props} actions={rowActions} />
    }
    
      return (
        <div>
          <DataGrid 
                columns={columns} 
                endPoint={`/api/admin/stores/${id}/users`}  
                headerActions={headerActions}
                exportFileName='Users' />
        <DetailDialog 
          open={openEditor} 
          title={"Gift Editor"}
          onClose={()=>setOpenEditor(false)} 
          fullScreen={false}>
            <Box sx={{p:2}}>
                <UserEditor data={current} storeId={id} onChange={()=>setOpenEditor(false)} onCancel={()=>setOpenEditor(false)} />
            </Box>
        </DetailDialog>
        <ConfirmationDialog
          open={openDialog}
          onClose={handleClose}
          onConfirm={handleConfirm}
          type={dialogProps.type}
          title={dialogProps.title}
          message={dialogProps.message}
          confirmText={dialogProps.confirmText}
          cancelText={dialogProps.cancelText}
        />
        </div>
        );
};

Users.propTypes = {
    id: PropTypes.string.isRequired,
};

export default Users;